// Textos de /contacto (guía 8.11). Los tres caminos y sus acciones son los de la guía;
// el formulario es la opción secundaria, debajo.

import { contact } from "./site";
import type { WhatsappContext } from "./whatsapp";

export type ContactAction =
  | { kind: "whatsapp"; context: WhatsappContext; label: string }
  | { kind: "page"; href: string; label: string }
  | { kind: "mail"; subject: string; label: string };

export type ContactPath = { id: string; title: string; body: string; actions: ContactAction[] };

export const contactPaths: ContactPath[] = [
  {
    id: "negocio",
    title: "Tengo un negocio",
    body: "Contanos qué querés resolver.",
    actions: [{ kind: "whatsapp", context: "general", label: "Escribinos por WhatsApp" }],
  },
  {
    id: "prensa",
    title: "Soy periodista",
    body: "Material, datos y entrevistas.",
    actions: [
      { kind: "page", href: "/prensa", label: "Ir a Prensa" },
      { kind: "mail", subject: "Prensa", label: `Escribinos a ${contact.email}` },
    ],
  },
  {
    id: "inversion",
    title: "Inversión y alianzas",
    body: "Hablemos con calma.",
    actions: [{ kind: "mail", subject: "Inversión y alianzas", label: `Escribinos a ${contact.email}` }],
  },
];

export const contactForm = {
  title: "También podés dejarnos un mensaje.",
  body: `Si preferís no usar WhatsApp ni el mail, completá esto. Te respondemos desde ${contact.email}.`,
  labels: {
    name: "Nombre",
    email: "Mail",
    company: "Empresa u organización",
    optional: "opcional",
    service: "Motivo",
    message: "Mensaje",
    honeypot: "No completes este campo",
  },
  submit: "Enviar mensaje",
  sending: "Enviando…",
  invalid: "Revisá los campos marcados.",
  network: "No pudimos conectar con el sitio. Revisá tu conexión y probá de nuevo.",
  generic: "No pudimos enviar tu mensaje. Probá de nuevo o escribinos por WhatsApp.",
  successTitle: "Mensaje enviado.",
  successBody: `Gracias. Te respondemos desde ${contact.email}.`,
  again: "Escribir otro mensaje",
  privacyBefore: "Lo que mandás se guarda como explicamos en ",
  privacyLink: "Privacidad",
  privacyAfter: ".",
  noscript: `El formulario necesita JavaScript. Podés escribirnos a ${contact.email} o por WhatsApp.`,
} as const;

export const contactChannels = {
  title: "Mail y redes",
  copyMail: "Copiar mail",
} as const;
